import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { Configuration, Cookbook, FoodRequestOptions, ServerResponse, UserCredentials } from '../models';
import { AccountService } from './account.service';
import { AppConfig } from './app.config';
import { RestService } from './rest.service';

@Injectable()
export class CookbookService {

  constructor(
    private restService: RestService,
    private accountService: AccountService
  ) {
    this.Config = AppConfig.config;
  }

  private Config: Configuration;

  private requestOptions = new FoodRequestOptions();
  private cookbooks: Cookbook[];
  private promise: Promise<Cookbook[]>;

  private refresh(): Promise<Cookbook[]> {

    if (this.promise) {
      return this.promise;
    }

    this.promise = new Promise<Cookbook[]>(resolve => {
      this.accountService.getCredentialsPromise().then(cred => {
        this.requestOptions.ApiVersion = 'v1';
        this.requestOptions.Id_session = cred.Id_Session;
        this.requestOptions.Id_app = this.Config.AppId;
        this.requestOptions.ManualJSON = 0;
        this.requestOptions.Controller0 = 'dictionary';
        this.requestOptions.Section = 'book/null/section';
        this.requestOptions.Method = 'print';

        this.restService.get(
          this.requestOptions).then(x => {
            if (x !== null) {
              const response: ServerResponse<Cookbook> = x;
              this.cookbooks = response.Result.Resultset;
              resolve(this.cookbooks);
            }
          });
      });
    });
    return this.promise;
  }

  public get(forceUpdate = false): Promise<Cookbook[]> {
    return new Promise<Cookbook[]>(resolve => {
      if (!this.cookbooks && !forceUpdate) {
        this.refresh().then(result => {
          resolve(result);
        });
        return;
      }
      resolve(this.cookbooks);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cookbook.service.ts